/**
 * SPAET LADEN — Takt, Ruhe und Sichtbarkeit fuer Fremdcode (Phase D Teil 2, Paket P5).
 *
 * Der fruehe Teil steht inline in snippets/ap-spaet-kopf.liquid (Einstellungen, Ausloeser ohne
 * Einwilligungsbanner, Abzeichen-Starthaken, Notlauf). Diese Datei (defer) uebernimmt, was nach
 * dem Ausloeser passiert:
 *
 *   TAKT (Plan-Kritik K18): Anbieter NACHEINANDER, je einer in einem eigenen Leerlauf-Abschnitt
 *     (requestIdleCallback mit Zeitlimit, sonst setTimeout) — nie im Ereignis-Handler und nie
 *     zwei in derselben Aufgabe. Reihenfolge nach Sichtbarkeit: Anbieter mit Platz im Bild zuerst,
 *     dann schwebende (ohne Platz), dann Plaetze ausserhalb des Bildes. Kaufknopf und
 *     PayPal-Express sind keine Anbieter dieser Datei und bleiben sofort (DB-7).
 *   SICHTBARKEIT: Modus „sichtbarkeit" startet einen Anbieter, sobald sein Platz in die Naehe des
 *     Bildes kommt (IntersectionObserver, 200 px Vorlauf) — oder bei der ersten Interaktion,
 *     was zuerst eintritt. Ohne Platz wie „interaktion".
 *   RUHE (K14): spaet geladene SCHWEBENDE Elemente erscheinen erst nach RUHE_MS ohne Scrollen,
 *     nie waehrend eines Wischens. Beim Google-Haendlerabzeichen: die Huelle der App traegt nach
 *     dem Start data-ap-ruhe (Stil im Kopf-Snippet: gerendert, aber durchsichtig — 16.10.); sobald die App sie zeigt
 *     (Attribut hidden faellt) UND die Seite ruht, faellt das Attribut. Danach meldet das
 *     Ereignis ap:spaet-geladen (detail.anbieter) den Anbieter — assets/ap-schwebe.js (P1) und
 *     assets/ap-app-a11y.js nehmen ihn dann auf. Stufe B (int:spaet-b): dasselbe fuer die
 *     Inbox-Blase (<shopify-chat>) und den Judge.me-Reiter (section.jdgm-revs-tab) — vorFreigabe/
 *     nachFreigabe, gerufen vom Kopf um die Freigabe der per Typwechsel geblockten Skripte.
 *   TAKT Stufe B: eine Freigabe gibt ein Versprechen zurueck; der naechste Anbieter kommt erst,
 *     wenn die Skripte des vorigen eingesetzt und geladen sind (nie zwei Anbieter zugleich).
 *   PAUSE Stufe B (Nachbesserung B2, M1-f PD-18, 12.10.2026): PayPal-Ratenhinweis, Judge.me und Inbox
 *     starten nach dem Ausloeser erst in einer PAUSE des Besuchers — RUHE_FREMD_MS (5 s) ohne Eingabe
 *     (Scrollen, Wischen, Beruehren, Tippen, Tasten) — und jedes weitere Glied ihrer Kette ebenfalls
 *     (S.nachRuhe im Kopf-Snippet). Gemessen (PD-18, mobil, 4x): direkt nach dem Ausloeser liefen die
 *     drei Anbieter ~11 s lang in langen Aufgaben (SDK 384–528 ms, Judge.me 300–420 ms) und trafen den
 *     Kauf-Tipp und die Mengenaenderung (INP2/INP3 bis +376 ms gegen sofort). Bedienfolgen wie Wischen ->
 *     Kaufen -> Menge (Abstaende 1,2–3,8 s) laufen jetzt ungestoert; der Fremdcode laeuft in der ersten
 *     laengeren Pause. Das Abzeichen (Stufe A, eigene Regel am Andockplatz) bleibt beim Leerlauf-Abschnitt.
 *   LIVE-BEFUND 16.10.2026 (Rollout reifenfair, „Chat und Google-Abzeichen nicht sichtbar, Abzeichen kurz breiter“):
 *     (1) KOPFSPERRE: die Startaufgabe des Abzeichens stand in DERSELBEN Schlange hinter PayPal, Inbox und Judge.me;
 *     pumpe() laesst nichts ueberholen — das Abzeichen bekam so die 5-s-Pause der Stufe B mit und startete bei
 *     Eingaben im Abstand unter 5 s nie. Jetzt hat Stufe A eine eigene Schlange (schlangeA/pumpeA).
 *     (2) KEINE KAPPE der Pause (Gegenpruefung 16.10.2026): wer nie RUHE_FREMD_MS ruht, bekommt Stufe B (Chat,
 *     PayPal-Hinweis, Judge.me) erst in seiner ersten Pause — B2 bleibt; ein Start schon nach 1 s Ruhe traefe wieder
 *     Kauf-Tipp und Menge (PD-18: SDK 384–528 ms, Judge.me 300–420 ms), INP dafuer ungemessen.
 *     (3) CHAT-KNOPF: chat.js verlegt den Knopf ~0,2–0,9 s nach dem ersten Bild in den Schattenbaum von
 *     <shopify-agent-runtime exportparts="activator, dialog">; die Pruefung fand ihn dort nicht (60 s verborgen).
 *     (4) ABZEICHEN: waehrend der Ruhe GERENDERT und durchsichtig (Kopf-Stil: opacity statt visibility, Huelle inert) —
 *     ein unsichtbarer fremder Rahmen bekam nach dem Seitenaufbau kaum Rechenzeit (eigener Renderer, Windows
 *     „Leerlauf“) und meldete seine Groesse spaet oder nie. Frei erst als fertige Scheibe an ihrem Platz: nicht als Pille
 *     der App (368 x 84) und nicht vor der Platzierung durch automotive.js (sonst „kurz breiter“ und Gleiten).
 *   ANDOCKPLATZ (M1-c, PD-18, 10.10.2026): wo das Haendlerabzeichen andockt (Handy, Tablet, schmale
 *     Fenster — es steht dort nur am Ende der Fusszeile), startet es erst, wenn dieser Platz nach dem
 *     Ausloeser in die Naehe des Bildes kommt; sein Start traf sonst die naechste Eingabe. Freigegeben
 *     (Ruhe) wird es erst, wenn es FERTIG steht (Huelle mit Groesse, nicht geparkt; im Andock-Modus der
 *     Platz mit Andock-Hoehe ganz im Bild) und die Seite 1 s ruht — geprueft nach der Ruhe am lebenden
 *     Zustand (F3) — sonst erschiene es beim Hereinrollen des Platzes mitten im Wischen (PD-19).
 *     Rand-Modus (breite Fenster) und Seiten ohne Platz: Start beim Ausloeser wie oben.
 *
 * Nichts hier schaltet etwas ab: ein Anbieter, dessen Aufgabe scheitert, laeuft im Notfall wie
 * bisher; Fehler einer Aufgabe halten die naechste nicht auf.
 */
(function () {
  'use strict';

  var S = window.apSpaet;
  if (!S || S.weiter) return;

  var RUHE_MS = 1000;
  var LEERLAUF_MAX_MS = 1500;
  var VORLAUF_PX = 200;
  // Nachbesserung B2 (M1-f, PD-18): Pause des Besuchers vor jedem Start (und jedem Glied) von Stufe-B-Fremdcode.
  var RUHE_FREMD_MS = 5000;
  var FREMD = { paypal: 1, judgeme: 1, inbox: 1 };
  // Judge.me „sichtbarkeit" (Betreiber 20.10.2026: Bewertungen laden, wenn der Besucher sich dem Kasten naehert). Der Platz
  // (Bewertungskasten bzw. Karussell, Kopf-Snippet PLATZ — nicht die Sterne am Titel, die zeichnet das Theme selbst) steht
  // weit unter dem Kaufbereich: NUR der Platz startet (nicht die erste Eingabe), mit einer Bildhoehe Vorlauf, und danach
  // gilt RUHE_MS statt RUHE_FREMD_MS — vorher kamen die Bewertungen erst in der ersten 5-s-Pause je Glied der Kette
  // (gemessen 20.10.: 11,2 s ohne Eingabe; wer weiterliest, sah sie nie).
  var VORLAUF_NAH = '0px 0px 100% 0px';
  var nahFrei = {};
  // Judge.me „laden" (Betreiber 22.10.2026: „bewertungen laden muss schneller gehen … rechts der Button, der angepinnt ist,
  // kommt gar nicht"): der angepinnte Reiter gehoert zu Judge.me und erschien bei „sichtbarkeit" erst am Bewertungskasten
  // (CST-Seite: 6.330 px tief). „laden" startet Judge.me nach dem Seitenaufbau OHNE Eingabe und ohne Platz — mit Vorrang
  // und RUHE_MS wie am Platz (der Aufruf selbst wartet weiter auf load + Leerlauf, Kopf-Snippet nachLadenUndLeerlauf).

  /* ---- Ruhe: letzte Bewegung der Seite ---------------------------------------------------- */
  /* Nachbesserung B1 (M1-f, PD-19, 12.10.): als Bewegung zaehlt auch der Finger selbst — Aufsetzen, Heben, Abbruch
   * (touchstart/touchend/touchcancel) und Tippen (pointerdown/pointerup). Vorher zaehlte nur Scrollen/Wischen: hob
   * der Finger erst 150 ms nach dem letzten Scroll ab (Halten am Ende der Geste), erschien der Judge.me-Reiter
   * schon 850 ms nach dem Heben (Rekorder: Ruhe ab der letzten Beruehrung). Die 1 s Ruhe beginnt jetzt mit der
   * letzten Beruehrung. Hoerer passiv im Erfassungsweg, nie im Handler Layout lesen.
   * Nachbesserung B2: auch Tasten (keydown) sind Bewegung (Pause vor Stufe-B-Fremdcode, Suche, Formulare). */
  var letzteBewegung = -1e9;
  function bewegt() {
    letzteBewegung = window.performance.now();
  }
  ['scroll', 'wheel', 'touchmove', 'touchstart', 'touchend', 'touchcancel', 'pointerdown', 'pointerup', 'keydown'].forEach(function (t) {
    window.addEventListener(t, bewegt, { capture: true, passive: true });
  });

  /** Letzte Bewegung — mindestens der Ausloeser selbst: der Kopf merkt sich seine Zeit (S.ausloeserZeit), BEVOR er die
   *  Aufgaben einreiht; die Hoerer oben laufen fuer dasselbe Ereignis erst danach (B2). */
  function zuletztBewegt() {
    return typeof S.ausloeserZeit === 'number' && S.ausloeserZeit > letzteBewegung ? S.ausloeserZeit : letzteBewegung;
  }

  /** fn erst, wenn die Seite `ms` (Vorgabe RUHE_MS) nicht bewegt wurde (je Pruefung EIN Zeitgeber, kein Abfragen je Bild). */
  function nachRuhe(fn, ms) {
    var soll = typeof ms === 'number' ? ms : RUHE_MS;
    var rest = soll - (window.performance.now() - zuletztBewegt());
    if (rest <= 0) return fn();
    window.setTimeout(function () {
      nachRuhe(fn, soll);
    }, Math.ceil(rest) + 16);
  }

  /** Eigener Leerlauf-Abschnitt (nie im Handler, nie zwei Anbieter in einer Aufgabe). */
  function leerlauf(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: LEERLAUF_MAX_MS });
    } else {
      window.setTimeout(fn, 1);
    }
  }

  /* ---- Takt: Schlange der Anbieter ------------------------------------------------------- */
  var schlange = [];
  var laeuft = false;
  // Live-Befund 16.10.2026 (1), KOPFSPERRE: Stufe A (Abzeichen) hat eine EIGENE Schlange — in der gemeinsamen wartete sie
  // hinter der Pause der Stufe B. Takt je Stufe wie bisher: ein Anbieter je Leerlauf-Abschnitt, nie zwei in einer Aufgabe.
  var schlangeA = [];
  var laeuftA = false;

  function platzElement(p) {
    if (!p) return null;
    if (typeof p === 'string') return document.querySelector(p);
    return p.nodeType === 1 ? p : null;
  }

  /** 0 = Platz im Bild, 1 = ohne Platz (schwebend), 2 = Platz ausserhalb des Bildes. */
  function rang(aufgabe) {
    var el = platzElement(aufgabe.platz);
    if (!el) return 1;
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > 0 && r.top < h ? 0 : 2;
  }

  /** Judge.me im Modus „sichtbarkeit" mit sichtbarem Platz: wartet NUR auf seinen Platz. Ohne Platz (oder ohne
   *  IntersectionObserver) wie „interaktion" — nie unsichtbar haengen. */
  function nurNah(aufgabe) {
    if (!aufgabe || aufgabe.anbieter !== 'judgeme' || S.modus('judgeme') !== 'sichtbarkeit') return false;
    if (!sichtAufgaben || !('IntersectionObserver' in window)) return false;
    var el = platzElement(aufgabe.platz);
    return !!(el && el.getClientRects().length);
  }

  /** Pause vor Stufe-B-Fremdcode: RUHE_MS, wenn der Besucher am Platz angekommen ist (nurNah), sonst RUHE_FREMD_MS. */
  function ruheFuer(anbieter) {
    return nahFrei[anbieter] ? RUHE_MS : RUHE_FREMD_MS;
  }

  /** Start eines Stufe-B-Anbieters (B2): erst nach der Pause ohne Eingabe (ruheFuer), dann im Leerlauf-Abschnitt; kam
   *  waehrend des Wartens auf den Leerlauf eine Eingabe, beginnt die Pause neu. Das Abzeichen (Stufe A): Leerlauf wie bisher. */
  function startbereit(aufgabe, fn) {
    if (!aufgabe || !FREMD[aufgabe.anbieter]) return leerlauf(fn);
    var ms = ruheFuer(aufgabe.anbieter);
    nachRuhe(function () {
      leerlauf(function () {
        if (window.performance.now() - zuletztBewegt() < ms) return startbereit(aufgabe, fn);
        fn();
      });
    }, ms);
  }

  /** Stufe A (Abzeichen): eigene Schlange, Leerlauf-Abschnitt ohne Pause — nie hinter Stufe B (Kopfsperre). */
  function pumpeA() {
    if (laeuftA || !schlangeA.length) return;
    laeuftA = true;
    leerlauf(function () {
      var aufgabe = schlangeA.shift();
      try {
        if (aufgabe && !aufgabe.erledigt) {
          aufgabe.erledigt = true;
          aufgabe.fn();
        }
      } catch (e) {
        /* Ein Anbieter darf die anderen nicht aufhalten. */
      }
      laeuftA = false;
      pumpeA();
    });
  }

  // laedt: ein Stufe-B-Anbieter laeuft (vom Start bis zu seinem Ende); runde: verwirft eine wartende Pause, wenn
  // Judge.me am Platz vorgeht (vorrang).
  var laedt = false;
  var runde = 0;

  function pumpe() {
    if (laeuft || !schlange.length) return;
    laeuft = true;
    var meine = ++runde;
    startbereit(schlange[0], function () {
      if (meine !== runde) return;
      var aufgabe = schlange.shift();
      laedt = true;
      var weiter = function () {
        laedt = false;
        laeuft = false;
        pumpe();
      };
      var erg;
      try {
        if (aufgabe && !aufgabe.erledigt) {
          aufgabe.erledigt = true;
          erg = aufgabe.fn();
        }
      } catch (e) {
        /* Ein Anbieter darf die anderen nicht aufhalten. */
      }
      // Stufe B (K18): gibt die Aufgabe ein Versprechen zurueck (Freigabe geblockter Skripte, externe werden
      // abgewartet), bekommt der naechste Anbieter seinen Leerlauf-Abschnitt erst danach — nie zwei zugleich.
      if (erg && typeof erg.then === 'function') erg.then(weiter, weiter);
      else weiter();
    });
  }

  function einreihen(liste) {
    if (!liste || !liste.length) return;
    // Reihenfolge nach Sichtbarkeit — EIN Lesedurchgang beim Einreihen, stabil je Rang.
    var mitRang = liste
      .filter(function (a) {
        return a && !a.erledigt;
      })
      .map(function (a, i) {
        return { a: a, r: rang(a), i: i };
      });
    mitRang.sort(function (x, y) {
      return x.r - y.r || x.i - y.i;
    });
    for (var i = 0; i < mitRang.length; i++) {
      var a = mitRang[i].a;
      if (a.laden) nahFrei[a.anbieter] = true;
      if (a.nah || a.laden) vorrang(a);
      else (FREMD[a.anbieter] ? schlange : schlangeA).push(a);
    }
    pumpeA();
    pumpe();
  }

  /** Judge.me am Platz (nurNah) geht in der Stufe-B-Schlange vor — sonst wartete es hinter der 5-s-Pause von Chat und
   *  PayPal-Hinweis (gemessen 20.10.: 5,6 s ab Ankunft). Laeuft gerade kein Anbieter, wird deren wartende Pause verworfen;
   *  laeuft einer, kommt Judge.me als naechster (nie zwei Anbieter zugleich, K18). */
  function vorrang(aufgabe) {
    schlange.unshift(aufgabe);
    if (laeuft && !laedt) {
      runde++;
      laeuft = false;
    }
  }

  /* ---- Sichtbarkeit: Platz in der Naehe des Bildes startet vor dem Ausloeser -------------------- */
  var sichtBeobachter = {}; // je Vorlauf ein Beobachter: VORLAUF_PX rundum, Judge.me „nah" VORLAUF_NAH
  var sichtAufgaben = typeof Map === 'function' ? new Map() : null;

  function beobachteSichtbarkeit(aufgabe) {
    var el = platzElement(aufgabe.platz);
    if (!el || !sichtAufgaben || !('IntersectionObserver' in window) || aufgabe.beobachtet) return;
    aufgabe.beobachtet = true;
    var nah = nurNah(aufgabe);
    var rand = nah ? VORLAUF_NAH : VORLAUF_PX + 'px 0px';
    if (!sichtBeobachter[rand]) {
      sichtBeobachter[rand] = new window.IntersectionObserver(
        function (eintraege) {
          eintraege.forEach(function (e) {
            if (!e.isIntersecting) return;
            var liste = sichtAufgaben.get(e.target) || [];
            sichtAufgaben.delete(e.target);
            sichtBeobachter[rand].unobserve(e.target);
            var frei = liste.filter(function (a) {
              var i = S.warte.indexOf(a);
              if (i > -1) S.warte.splice(i, 1);
              if (a.nah) nahFrei[a.anbieter] = true;
              return !a.erledigt;
            });
            einreihen(frei);
          });
        },
        { rootMargin: rand }
      );
    }
    aufgabe.nah = nah;
    var liste = sichtAufgaben.get(el);
    if (!liste) sichtAufgaben.set(el, (liste = []));
    liste.push(aufgabe);
    sichtBeobachter[rand].observe(el);
  }

  /** Die erste Eingabe startet alles Wartende — ausser Judge.me „nah": das beobachtet weiter nur seinen Platz. */
  function nachEingabe(liste) {
    einreihen(
      (liste || []).filter(function (a) {
        if (!nurNah(a)) return true;
        beobachteSichtbarkeit(a);
        return false;
      })
    );
  }

  /* ---- Meldung nach dem Erscheinen ------------------------------------------------------------ */
  function melde(anbieter) {
    try {
      document.dispatchEvent(new CustomEvent('ap:spaet-geladen', { detail: { anbieter: anbieter } }));
    } catch (e) {
      /* sehr alte Browser ohne CustomEvent-Konstruktor: nichts melden */
    }
  }

  /**
   * Abzeichen (App „Google & YouTube"): nach start() unsichtbar halten (data-ap-ruhe), bis es FERTIG
   * steht — so, wie assets/automotive.js es zeigen will — UND die Seite 1 s ruht; erst dann melden.
   * Gerufen vom Starthaken im Kopf-Snippet direkt nach start().
   *
   * Nachbesserung F3 (M1-c, PD-19, 10.10.2026): F2b gab frei, sobald die App das Attribut `hidden` fallen
   * liess — da hatte die Huelle oft noch 0 x 0 px, und der Andockplatz war noch 0 px hoch (er waechst erst
   * mit body.ap-abzeichen-andocken um Standlinie + Kante + 16 px, sobald automotive.js die fertige Huelle
   * andockt). Ein 0 px hoher Platz zaehlt als „ganz im Bild“; die Freigabe fiel darum am alten Seitenende,
   * dann wuchs die Seite, automotive.js parkte das Abzeichen, und beim naechsten Wischen zum neuen Ende
   * erschien es MITTEN im Wischen (Rekorder ende2-start-768 und wisch-cart-390). Jetzt prueft die Freigabe
   * NACH der Ruhe am lebenden Zustand: Huelle sichtbar und mit Groesse, nicht geparkt; im Andock-Modus
   * zusaetzlich Platz mit Andock-Hoehe und ganz im Bild. Stimmt etwas nicht, bleibt das Abzeichen unsichtbar
   * und die naechste Aenderung (App, automotive.js, Platz) prueft neu. Layout wird nur nach der Ruhe gelesen.
   * Nie unsichtbar haengen: dockt automotive.js trotz Andock-Formel nicht an (andere Kante der App, Skript
   * fehlt), gibt die Freigabe nach ABZ_OHNE_ANDOCKEN_MS wie im Rand-Modus frei.
   *
   * Live-Befund 16.10.2026 (4): waehrend der Ruhe ist die Huelle GERENDERT und nur durchsichtig (Kopf-Stil: display block
   * gegen das hidden der App, opacity 0, keine Treffer, keine Transition) und inert (kein Fokus, nicht im
   * Barrierefreiheitsbaum). Mit visibility hidden bzw. display none galt der fremde Rahmen als nicht gerendert: sein
   * Renderer stand nach dem Seitenaufbau auf Windows-Prioritaet „Leerlauf“, und die App meldete ihre Groesse unter Last
   * spaet oder nie (Erhebung 16.10.2026, reifenfair im Spaet-Modus: in 8 von 11 Laeufen kam 43–92 s nach dem Anlegen der
   * Huelle kein Handschlag des Rahmens). Frei wird erst die fertige SCHEIBE (nicht die Pille 368 x 84 / 400 x 68 der
   * ersten Meldung) an der Stelle, an die automotive.js sie gesetzt hat (Huelle.__apAbzVersteckt nicht mehr true) —
   * sonst sah man 0,02–0,5 s die breite Pille in Rohlage, bis zur Scheibe (2,3–2,8 s) eine abgeschnittene Pille und
   * das Gleiten in den Rand („kurz breiter, hinter dem Inhalt“). Nie unsichtbar haengen: nach ABZ_UNFERTIG_MAX_MS frei wie
   * bisher.
   */
  var ABZ_OHNE_ANDOCKEN_MS = 2000;
  var ABZ_UNFERTIG_MAX_MS = 6000;
  function ruheAbzeichen(huelle) {
    if (!huelle || huelle.__apRuhe) return;
    huelle.__apRuhe = true;
    huelle.setAttribute('data-ap-ruhe', '');
    huelle.inert = true;
    var gemeldet = false;
    var wartet = false;
    var beobachter = null;
    var platzBeob = null;
    var ohneAndockenSeit = null;
    var vermessen = false;
    var unfertig = false;
    var unfertigSeit = null;
    var unfertigUhr = null;
    function freigeben() {
      gemeldet = true;
      if (beobachter) beobachter.disconnect();
      if (platzBeob) platzBeob.disconnect();
      huelle.removeAttribute('data-ap-ruhe');
      huelle.inert = false;
      melde('abzeichen');
    }
    if (typeof MutationObserver !== 'function') {
      // Ohne Beobachter nie unsichtbar haengen bleiben: nach der Ruhe freigeben (wie bisher sichtbar).
      nachRuhe(freigeben);
      return;
    }
    function pruefe() {
      if (gemeldet || wartet) return;
      wartet = true;
      nachRuhe(function () {
        wartet = false;
        if (gemeldet) return;
        var zustand = abzeichenZustand(huelle, unfertigSeit !== null && window.performance.now() - unfertigSeit >= ABZ_UNFERTIG_MAX_MS);
        if (zustand === 'bereit') return freigeben();
        if (zustand !== 'unvermessen') vermessen = true;
        // Pille oder noch nicht gesetzt: Stil-Aenderungen zaehlen wieder (Scheibe der App, Platzierung durch automotive.js).
        // Die Frist laeuft je Abschnitt: geparkt zwischendurch (Andocken) beginnt sie beim naechsten Mal neu.
        // Geparkt (visibility hidden) schickte der Rahmen live die Scheibe erst ~0,6 s nach dem Entparken (16.10.2026,
        // 115 s geparkt) — die Frist beginnt darum erst am Platz; Probe: tests/phase-d-spaet.test.js Abschnitt 14.
        unfertig = zustand === 'unfertig';
        if (!unfertig) unfertigSeit = null;
        if (unfertig) {
          if (unfertigSeit === null) unfertigSeit = window.performance.now();
          if (!unfertigUhr) {
            unfertigUhr = window.setTimeout(function () {
              unfertigUhr = null;
              pruefe();
            }, Math.ceil(ABZ_UNFERTIG_MAX_MS - (window.performance.now() - unfertigSeit)) + 16);
          }
          return;
        }
        if (zustand !== 'ohne-andocken') {
          ohneAndockenSeit = null;
          return;
        }
        // Andock-Modus nach der Formel, aber noch keine Andock-Klasse: automotive.js verarbeitet die Huelle im
        // naechsten Bild (dann meldet der Beobachter neu). Bleibt es dabei, nie unsichtbar haengen.
        var jetzt = window.performance.now();
        if (ohneAndockenSeit === null) ohneAndockenSeit = jetzt;
        if (jetzt - ohneAndockenSeit >= ABZ_OHNE_ANDOCKEN_MS) return freigeben();
        window.setTimeout(pruefe, Math.ceil(ABZ_OHNE_ANDOCKEN_MS - (jetzt - ohneAndockenSeit)) + 16);
      });
    }
    // Die Huelle der App ist bis zur ersten resize-Nachricht ihres Iframes `hidden` (merchantwidget.js, D/q);
    // ihre Groesse setzt die App per Stil, Parken und Entparken setzt automotive.js (data-ap-geparkt). Stil-
    // Aenderungen zaehlen nur, bis die Huelle einmal Groesse hatte — die App setzt ihren Stil fortlaufend
    // (automotive.js, DT-1); danach melden data-ap-geparkt, hidden und der Platz-Beobachter jeden Wechsel.
    beobachter = new MutationObserver(function (liste) {
      if (!liste || !vermessen || unfertig) return pruefe();
      for (var i = 0; i < liste.length; i++) if (liste[i].attributeName !== 'style') return pruefe();
    });
    beobachter.observe(huelle, { attributes: true, attributeFilter: ['hidden', 'style', 'data-ap-geparkt'] });
    var platz = document.getElementById('ap-abzeichen-platz');
    if (platz && 'IntersectionObserver' in window) {
      platzBeob = new window.IntersectionObserver(pruefe, { threshold: [0, 0.95, 1] });
      platzBeob.observe(platz);
    }
    pruefe();
  }

  /**
   * Steht das Abzeichen jetzt so, wie automotive.js es zeigen will? Liest Layout — nur nach der Ruhe rufen.
   * 'bereit' | 'unvermessen' | 'warten' | 'unfertig' | 'ohne-andocken'. Rand-Modus und Seiten ohne Platz: Huelle
   * gezeigt, mit Groesse (sonst 'unvermessen'), nicht geparkt, als Scheibe und von automotive.js gesetzt (sonst
   * 'unfertig' — ausser `unfertigOk`, nach ABZ_UNFERTIG_MAX_MS). Andock-Modus zusaetzlich: body.ap-abzeichen-andocken
   * (sonst 'ohne-andocken') und der Platz mit seiner Andock-Hoehe ganz im Bild (>= 95 %, wie automotive.js; ein 0 px
   * hoher Platz zaehlt nicht).
   */
  function abzeichenZustand(huelle, unfertigOk) {
    if (huelle.hidden || !(huelle.offsetWidth >= 2) || !(huelle.offsetHeight >= 2)) return 'unvermessen';
    if (huelle.hasAttribute('data-ap-geparkt')) return 'warten';
    if (!unfertigOk && (abzeichenPille(huelle) || huelle.__apAbzVersteckt === true)) return 'unfertig';
    var platz = abzeichenAndockplatz();
    if (!platz) return 'bereit';
    var body = document.body;
    if (!body || !body.classList.contains('ap-abzeichen-andocken')) return 'ohne-andocken';
    var r = platz.getBoundingClientRect();
    var hoehe = window.innerHeight || document.documentElement.clientHeight || 0;
    var imBild = Math.min(r.bottom, hoehe) - Math.max(r.top, 0);
    return r.height >= 2 && imBild / r.height >= 0.95 ? 'bereit' : 'warten';
  }

  /** Zeigt die App gerade ihre PILLE („Händlerqualität von Google“: erste Meldung 368 x 84 bzw. 400 x 68, die Scheibe
   *  84 x 84 bzw. 68 x 68 folgt 2,3–4,4 s spaeter — 18 Live-Laeufe 16.10.2026, mit dem Kopf-Stil 3,5–4,4 s; im
   *  Andock-Modus geparkt erst ~0,6 s nach dem Entparken)? Gelesen werden die INLINE-Masse der App — die Klemme von
   *  automotive.js begrenzt nur max-width. Das aufgeklappte Panel (Klick, 406 x 602) ist hoeher als breit. */
  function abzeichenPille(huelle) {
    var st = huelle.style;
    if (!st) return false;
    var b = parseFloat(st.width);
    var h = parseFloat(st.height);
    return b > 0 && h > 0 && b > h * 1.5;
  }

  /* ---- Abzeichen auf schmalen Fenstern: Start erst am Andockplatz (M1-c, PD-18, 10.10.2026) -------
   * Wo das Haendlerabzeichen nicht neben den Inhalt passt (Handy, Tablet, schmale Fenster), steht es NUR
   * an seinem Platz am Ende der Fusszeile (#ap-abzeichen-platz; assets/automotive.js „ANDOCKEN“) und
   * wartet sonst unsichtbar ausserhalb des Bildes. Sein Start (merchantwidget.start samt Iframe) kostet
   * mobil ~0,3–0,6 s Hauptfaden; direkt nach der ersten Interaktion traf er in M1-c die naechste Eingabe
   * (PD-18). Dort startet es darum erst, wenn der Andockplatz in die Naehe des Bildes kommt (eine
   * Bildhoehe Vorlauf) — sichtbar wird es an derselben Stelle wie heute, nichts wird abgeschaltet.
   * Im RAND-Modus (breite Fenster: es schwebt verkleinert links neben dem Inhalt) und ohne Andockplatz
   * bleibt es beim Ausloeser. Die Entscheidung liest Layout und faellt darum im Leerlauf-Abschnitt der
   * Aufgabe (nie im Ereignis-Handler), mit derselben Formel wie automotive.js:
   * ABZ_RAND_LINKS + Kante x ABZ_RAND_SKALA + 1 <= linke Inhaltskante (Kante 84 px, bis 480 px 68 px).
   */
  var ABZ_RAND_LINKS = 4;
  var ABZ_RAND_SKALA = 0.66;
  var ABZ_VORLAUF = '0px 0px 100% 0px';

  /** Andockplatz, wenn das Abzeichen hier andockt; null im RAND-Modus oder ohne Platz. */
  function abzeichenAndockplatz() {
    var platz = document.getElementById('ap-abzeichen-platz');
    if (!platz) return null;
    var kante = (window.innerWidth || 0) > 480 ? 84 : 68;
    var pw = document.querySelector('#MainContent .page-width');
    var links = 0;
    if (pw) links = pw.getBoundingClientRect().left + (parseFloat(window.getComputedStyle(pw).paddingLeft) || 0);
    return ABZ_RAND_LINKS + kante * ABZ_RAND_SKALA + 1 <= links ? null : platz;
  }

  /** Startaufgabe des Abzeichens: im Andock-Modus erst am Platz (bzw. wenn das Fenster breit genug wird). */
  function amAndockplatz(fn) {
    var gestartet = false;
    function los() {
      if (gestartet) return;
      gestartet = true;
      fn();
    }
    return function () {
      var platz = abzeichenAndockplatz();
      if (!platz || !('IntersectionObserver' in window)) return los();
      var geplant = false;
      var beob = new window.IntersectionObserver(
        function (eintraege) {
          for (var i = 0; i < eintraege.length; i++) {
            if (!eintraege[i].isIntersecting) continue;
            fertig();
            einreihen([{ anbieter: 'abzeichen', fn: los }]);
            return;
          }
        },
        { rootMargin: ABZ_VORLAUF }
      );
      function fertig() {
        beob.disconnect();
        window.removeEventListener('resize', breiteGeaendert);
      }
      // Wird das Fenster breit genug fuer den Rand, schwebt es dort wie bisher (Pruefung im Leerlauf).
      function breiteGeaendert() {
        if (geplant || gestartet) return;
        geplant = true;
        leerlauf(function () {
          geplant = false;
          if (gestartet || abzeichenAndockplatz()) return;
          fertig();
          los();
        });
      }
      beob.observe(platz);
      window.addEventListener('resize', breiteGeaendert, { passive: true });
    };
  }
  function abzeichenAufgabe(a) {
    if (a && a.anbieter === 'abzeichen' && !a.andock && S.modus('abzeichen') !== 'sofort') {
      a.andock = true;
      a.fn = amAndockplatz(a.fn);
    }
    return a;
  }

  /* ---- Stufe B: Chat-Blase und Judge.me-Reiter erst nach der Ruhe (K14) -------------------------
   * Der Kopf (snippets/ap-spaet-kopf.liquid) ruft vorFreigabe(anbieter) BEVOR er die geblockten Skripte eines
   * Anbieters einsetzt, und nachFreigabe(anbieter), sobald sie eingesetzt (externe geladen) sind. Schwebende
   * Bausteine bekommen vorher data-ap-ruhe (Stil im Kopf: visibility hidden): die Inbox-Blase an ihrem Wirt
   * <shopify-chat> (steht leer im Server-Markup; die App rendert in den Schattenbaum), der Judge.me-Reiter an
   * seinem Knopf .jdgm-revs-tab-btn (Server-Markup in section.jdgm-revs-tab; Judge.me schaltet ihn mit seinem
   * Stylesheet sichtbar — nur der Knopf, nie der Inhalt des Reiters, tests/judgeme-karten.test.js). Freigegeben
   * (Attribut faellt, ap:spaet-geladen) wird erst, wenn der Baustein STEHT — Blase mit Groesse im Schattenbaum,
   * Reiter-Knopf mit Groesse — und die Seite RUHE_MS ruht; geprueft nach der Ruhe am lebenden Zustand (wie das
   * Abzeichen, F3). Kommt der Baustein nicht (App rendert nicht, Netz), faellt das Attribut nach
   * SCHWEBE_MAX_MS trotzdem — nie unsichtbar haengen. Ohne diese Datei setzt der Kopf kein Attribut.
   * Nicht schwebende Anbieter (PayPal-Ratenhinweis in reservierter Zeile; Judge.me-Karussell auf der Buehne)
   * melden sich nach der Freigabe direkt: ap-app-a11y.js und automotive.js (initJudgeMeLeere) hoeren darauf.
   */
  var SCHWEBE_MAX_MS = 60000;
  var SCHWEBE_TAKT_MS = 300;
  /** Knopf der Chat-Blase: im Schattenbaum von <shopify-chat> — oder, nachdem chat.js ihn ~0,2–0,9 s nach dem ersten Bild
   *  in <shopify-agent-runtime exportparts="activator, dialog"> verlegt hat (live 16.10.2026), in DESSEN Schattenbaum.
   *  Vorher fand die Pruefung den verlegten Knopf nicht: lief sie erst nach dem Umzug (Eingabe beim Erscheinen), blieb
   *  die Blase bis SCHWEBE_MAX_MS verborgen. */
  function chatKnopf(el) {
    var r = el && el.shadowRoot;
    if (!r) return null;
    var akt = r.querySelector('[part~="activator"]');
    if (akt) return akt;
    var rt = r.querySelector('shopify-agent-runtime');
    return rt && rt.shadowRoot ? rt.shadowRoot.querySelector('[part~="activator"]') : null;
  }
  var SCHWEBEND = {
    inbox: { wirt: 'shopify-chat', steht: function (el) { var akt = chatKnopf(el); return !!akt && akt.offsetWidth >= 2 && akt.offsetHeight >= 2; } },
    judgeme: { wirt: '.jdgm-revs-tab-btn', melde: 'judgeme-reiter', steht: function (el) { return el.offsetWidth >= 2 && el.offsetHeight >= 2; } },
  };
  var schwebeWirte = {};

  function schwebeWirt(anbieter) {
    var s = SCHWEBEND[anbieter];
    if (!s) return null;
    var el = schwebeWirte[anbieter];
    if (el && el.isConnected) return el;
    el = document.querySelector(s.wirt);
    if (el) schwebeWirte[anbieter] = el;
    return el || null;
  }

  function vorFreigabe(anbieter) {
    var el = schwebeWirt(anbieter);
    if (el) el.setAttribute('data-ap-ruhe', '');
  }

  function ruheSchwebend(anbieter) {
    var s = SCHWEBEND[anbieter];
    var seit = window.performance.now();
    var gemeldet = false;
    function freigeben() {
      if (gemeldet) return;
      gemeldet = true;
      var el = schwebeWirt(anbieter);
      if (el) el.removeAttribute('data-ap-ruhe');
      melde(s.melde || anbieter);
    }
    function pruefe() {
      nachRuhe(function () {
        if (gemeldet) return;
        // Fehlte der Wirt bei vorFreigabe, wurde nichts verborgen (nachtraegliches Verbergen waere ein Blitz);
        // gemeldet wird trotzdem erst, wenn der Baustein steht und die Seite ruht.
        var el = schwebeWirt(anbieter);
        var fertig = !!el && s.steht(el);
        if (fertig || window.performance.now() - seit >= SCHWEBE_MAX_MS) return freigeben();
        window.setTimeout(pruefe, SCHWEBE_TAKT_MS);
      });
    }
    pruefe();
  }

  function nachFreigabe(anbieter) {
    if (SCHWEBEND[anbieter]) {
      ruheSchwebend(anbieter);
      // Judge.me-Karussell und -Widget stehen in der Flaeche (Buehne reserviert): sofort melden.
      if (anbieter === 'judgeme') melde('judgeme');
      return;
    }
    melde(anbieter);
  }

  /* ---- Anschluss an den fruehen Teil ---------------------------------------------------------- */
  S.weiter = nachEingabe;
  S.nachRuhe = nachRuhe;
  S.ruheFremd = RUHE_FREMD_MS; // B2: Pause vor jedem Glied der Kette eines Stufe-B-Anbieters (Kopf-Snippet, pause())
  S.ruheFuer = ruheFuer; // je Anbieter: Judge.me am Platz angekommen -> RUHE_MS
  S.melde = melde;
  S.ruheAbzeichen = ruheAbzeichen;
  S.vorFreigabe = vorFreigabe;
  S.nachFreigabe = nachFreigabe;

  // Schon wartende Abzeichen-Aufgaben (Einbettung vor dieser Datei) bekommen dieselbe Andock-Regel.
  S.warte.forEach(abzeichenAufgabe);
  // „laden" wartet auf keine Eingabe: gleich einreihen (der Aufruf selbst wartet auf load + Leerlauf).
  var ladenJetzt = S.warte.filter(function (a) {
    return a.laden;
  });
  if (ladenJetzt.length) {
    S.warte = S.warte.filter(function (a) {
      return !a.laden;
    });
    einreihen(ladenJetzt);
  }
  // Wartende Aufgaben: „sichtbarkeit" mit Platz beobachten; ist der Ausloeser schon gefallen
  // (Interaktion vor dem Laden dieser Datei), alles einreihen (Judge.me „nah" beobachtet weiter seinen Platz).
  if (S.ausgeloest) {
    nachEingabe(S.warte.splice(0));
  } else {
    S.warte.slice().forEach(function (a) {
      if (S.modus(a.anbieter) === 'sichtbarkeit' && a.platz) beobachteSichtbarkeit(a);
    });
  }
  var altNach = S.nachAusloeser;
  S.nachAusloeser = function (a, fn, platz) {
    if (a === 'abzeichen') fn = abzeichenAufgabe({ anbieter: a, fn: fn }).fn;
    if (S.modus(a) === 'sichtbarkeit' && platz && !S.ausgeloest) {
      var aufgabe = { anbieter: a, fn: fn, platz: platz };
      S.warte.push(aufgabe);
      beobachteSichtbarkeit(aufgabe);
      return;
    }
    return altNach(a, fn, platz);
  };
})();
